module.exports = __webpack_public_path__ + "assets/img/e488ff25f9864105f698aeff18c369bc.png";